import { AxiosResponse } from 'axios'

export async function data<T>(apiResponse: Promise<AxiosResponse<T>>): Promise<T> {
  const response = await apiResponse
  return response.data
}
